import { Component } from '@angular/core';

@Component({
  selector: 'ui-grid-container',
  template: `
    <div class="grid grid-flow-row grid-cols-1 sm:grid-cols-12 gap-2 sm:gap-4 max-w-[2048px] py-2 px-2 sm:px-6 mx-auto">
      <ng-content></ng-content>
    </div>
  `
})

export class GridContainerComponent {}
